<div attr.name="CellOS_{{ item.id }}" class="tCol clickCol desktop" id="CellOS_{{ item.id }}">
  @if (notManaged) {
    <span> </span>
  }
  @if (routerManaged) {
    <span class="image icon-routers"> </span>
  }
  @if (serviceManaged) {
    <span class="image icon-services"> </span>
  }
  @if (clientSyncManaged) {
    <span class="image icon-integrations"> </span>
  }
</div>
